import gsap from 'gsap'
import {smoothScrollKill, smoothScrollCreate, smoothScrollPause, smoothScrollPlay} from '../scroll-smoother'

//-- Show Hide on Scroll ---
let doc = document.documentElement;

let prevScroll = window.scrollY || doc.scrollTop;
let curScroll;
let direction = 0;
let prevDirection = 0;


document.addEventListener("DOMContentLoaded", function() {
    let popup = document.querySelector('.js--services-open-mobile-filter');
    let modal = document.querySelector('.js--services-filter-modal');
    let modalContent = document.querySelector('.js--services-filter-modal .inner-parent .inner-children');
    let closeButton = document.querySelector('.filter-modal-close-btn');
    let navigationBlock = document.querySelector('.left-navigation');

    if(popup){
        let checkScroll = function () {
            if (curScroll > prevScroll && curScroll > 200) {
                //scrolled up
                direction = 2;
            } else if (curScroll < prevScroll) {
                //scrolled down
                direction = 1;
            }
            if (direction !== prevDirection) {
                if (direction === 2) {
                    popup.classList.remove('displayed');
                } else {
                    popup.classList.add('displayed');
                }
                prevDirection = direction;
            }
            if (curScroll < 400 || -50 > navigationBlock.getBoundingClientRect().top - window.innerHeight) {
                popup.classList.add('is-hidden')
            } else {
                popup.classList.remove('is-hidden')
            }

            prevScroll = curScroll;
        };
        window.addEventListener('scroll', function(){
            curScroll = window.scrollY || doc.scrollTop;
            checkScroll()
        });
        let openModal = function () {
            modal.classList.add('modal-active');
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
            smoothScrollPause();
        }
        popup.addEventListener("click", openModal);
    }

    let closeModal = function () {
        modal.classList.remove('modal-active');
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
        smoothScrollPlay();
    };

    if(closeButton){
        closeButton.addEventListener('click', closeModal);
    }
    //To close modal while clicking outside
    modal.addEventListener('click', function (e) {
        closeModal();
    });
    modalContent.addEventListener('click', function (e) {
        e.stopPropagation();
    });

});